module.exports = __webpack_public_path__ + "static/media/8.125211e0.png";